import { useCallback, useEffect, useRef } from 'react';

export function useAutozoom(mapRef, visibleSites, loading, hideInactive) {
	const prevLoadingRef = useRef(false);

	const autozoom = useCallback(function(sitesToFit) {
		var map = mapRef.current;
		if (!map || !sitesToFit || sitesToFit.length === 0) return;
		var lats = sitesToFit.map(function(s) { return parseFloat(s.latitude);  }).filter(function(v) { return !isNaN(v); });
		var lngs = sitesToFit.map(function(s) { return parseFloat(s.longitude); }).filter(function(v) { return !isNaN(v); });
		if (lats.length === 0) return;
		map.fitBounds([
			[Math.min.apply(null, lats), Math.min.apply(null, lngs)],
			[Math.max.apply(null, lats), Math.max.apply(null, lngs)],
		], { padding: [40, 40], maxZoom: 12 });
	}, [mapRef]);

	// After Apply / Reset
	useEffect(function() {
		var wasLoading = prevLoadingRef.current;
		prevLoadingRef.current = loading;
		if (!wasLoading || loading) return;
		autozoom(visibleSites);
		 
	}, [loading]);

	// After Active Only toggle
	useEffect(function() {
		autozoom(visibleSites);
		 
	}, [hideInactive]);
}